(function () {
  'use strict';

  angular
    .module('smsManager')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('smsManager', {
        url: '/sms-manager',
        views: {
          'smsManagerView': {
            templateUrl: 'sms-manager/views/sms-manager.tpl.html',
            controller: 'SmsManagerCtrl',
            controllerAs: 'smsManager'
          }
        }
      });
  }
}());
